// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterBar-cls1_mKo","cls2":"FilterBar-cls2_UBD FilterBar-cls1_mKo"};